// Desktop Mobile Notice - Permanent banner for desktop users
(function() {
  'use strict';

  // Only show on desktop (1024px and wider)
  function isDesktop() {
    return window.innerWidth >= 1024;
  }

  // Get QR code from settings or generate default
  function getQRCodeUrl() {
    // Check if custom QR code is set in theme settings
    const customQRCode = window.desktopNoticeQRCode;
    if (customQRCode && customQRCode !== '') {
      return customQRCode;
    }

    // Fallback: generate QR code for current page
    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);
    return `https://chart.googleapis.com/chart?cht=qr&chs=200x200&chl=${encodedUrl}`;
  }

  // Create and show the notice
  function showNotice() {
    if (!isDesktop()) {
      return;
    }

    // Check if notice already exists
    if (document.querySelector('.desktop-mobile-notice')) {
      return;
    }

    const qrCodeUrl = getQRCodeUrl();

    // Create notice HTML
    const noticeHTML = `
      <div class="desktop-mobile-notice" role="banner" aria-label="Mobile experience notice">
        <div class="desktop-mobile-notice__container">
          <div class="desktop-mobile-notice__icon" aria-hidden="true">📱</div>
          <div class="desktop-mobile-notice__content">
            <p class="desktop-mobile-notice__title">
              For the best experience, please visit us on your mobile device
            </p>
            <p class="desktop-mobile-notice__subtitle">
              Our site is designed mobile-first for the perfect card browsing experience
            </p>
          </div>
          <div class="desktop-mobile-notice__qr" aria-label="QR code to open on mobile">
            <div class="desktop-mobile-notice__qr-code">
              <img src="${qrCodeUrl}" alt="QR code to open this page on mobile" loading="lazy" />
            </div>
            <span class="desktop-mobile-notice__qr-label">Scan to open</span>
          </div>
          <button
            class="desktop-mobile-notice__close"
            aria-label="Temporarily hide mobile notice"
            type="button"
            title="Hide this message (will return on next page)"
          >
            ×
          </button>
        </div>
      </div>
    `;

    // Insert notice at the top of body
    document.body.insertAdjacentHTML('afterbegin', noticeHTML);
    document.body.classList.add('desktop-notice-visible');

    // Add close functionality (only hides for current page view)
    const closeButton = document.querySelector('.desktop-mobile-notice__close');
    if (closeButton) {
      closeButton.addEventListener('click', dismissNotice);
    }

    // Dismiss on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        dismissNotice();
      }
    });
  }

  // Dismiss the notice temporarily (only for current page view)
  function dismissNotice() {
    const notice = document.querySelector('.desktop-mobile-notice');
    if (notice) {
      notice.style.animation = 'slideUp 0.3s ease';
      setTimeout(function() {
        notice.remove();
        document.body.classList.remove('desktop-notice-visible');
      }, 300);
    }
    // Note: No persistent storage - notice will reappear on next page
  }

  // Add slideUp animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideUp {
      from {
        transform: translateY(0);
        opacity: 1;
      }
      to {
        transform: translateY(-100%);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);

  // Show notice when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showNotice);
  } else {
    showNotice();
  }

  // Handle window resize - hide notice if user resizes to mobile
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (!isDesktop()) {
        const notice = document.querySelector('.desktop-mobile-notice');
        if (notice) {
          notice.remove();
          document.body.classList.remove('desktop-notice-visible');
        }
      } else {
        // Show notice again if user resizes back to desktop
        showNotice();
      }
    }, 250);
  });
})();
